import PromoFormDetail from './PromoFormDetail';

export default PromoFormDetail;